import cheader from '@/components/header/index.vue'
import caside from '@/components/aside/index.vue'

export default {
  name: 'user_good',
  data() {
    return {
      search: {
        title: ''
      },
      search2: {
        name: '',
        status: ''
      },
      options: [{
        value: '',
        label: '全部'
      }, {
        value: '1',
        label: '已对码'
      }, {
        value: '0',
        label: '未对码'
      }, {
        value: '2',
        label: '已申请'
      },],
      value: '',
      title:"",
      unitID: 0,
      goodsInfo:[],
      page: 1,
      page2: 1,
      selectedGoods: [],
      detailinfo: [],
      goods: [],
      goods2: [],
      total: 0,
      total2: 0,
      curpage: 1,
      curpage2: 1,
      cates: [],
      brands: [],
      presclass: [],
       // 部门树选项
      deptOptions: undefined,
      editFormVisiable: false,
      detailFormVisiable: false,
      codeFormVisiable: false,
      isClick:false,
      form: {
        pwd:"123456",
      },
      //性别
      sexOptions:[{
        dictLabel:"男",
        dictValue:1
      },{
        dictLabel:"女",
        dictValue:2
      }],
      statusOptions:[],
      roleOptions:[],
      rows:{},
      open:false,
      formPwd:{},
      pwdOpen:false,
      nowInfoId:"",
      setPwdTitle:"",
      isWayShowNew:false,
      nowData:{},
      timer: '',
      fileList:[],
      progressVal: 0,
      mergeFlag:"",
      serverUrl: this.$store.state.config.serverUrl,
      progressDisplay: false
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  components: {
    cheader,
    caside
  },
  created() {
    this.index(1)
    this.cateIndex()
    this.brandIndex()
    this.presclassIndex()
    this.orderSwitch()
  },
  methods: {
    // 表单重置
    reset() {
      this.form = {
        name: '',
        roleIds: "",
        mobile: '',
        email: '',
        loginName: '',
        pwd: ''
      };
      this.resetForm("form");
    },
   
    download() {
      window.location.href = `${this.$store.state.config.serverUrl}/static/doc/品种导入模板.xlsx`
    },
    orderSwitch() {
      if (this.user.id) {
        this.$http.get('/api/user/orderSwitch', {params: {comId: this.user.customerId}}).then((res) => {
          this.mergeFlag = res.data.message
        })
      }
    },
    searchByTag() {
      this.search.glid = this.value
      this.index(1)
    },
    success(e) {
      this.$message({
        type: 'success',
        message: e.message
      });
    },
    changeRole(){
      this.$forceUpdate()
    },
    async go(page,item) {
      this.page2 = page
      this.curpage2 = page
      this.open=true
      this.nowData = item
      this.nextGoods(page)
    },
    addUser(){
      this.isWayShowNew=true
    },
    nextGoods(page){
        this.page2 = page
        var item = this.nowData
        var params = {
            userId: this.user.id,
            companyId:this.user.customerId,
            pid:item.pid,
            page: page,
            pageSize:10
         }
        this.$http.get('/api/ucenter/pur/purOrder/item/list',{params:params}).then((res) => {
            if(res.data.success){
                this.goodsInfo = res.data.data
                this.total2 = res.data.total
            }
         })
    },
    uploadTemplateNew(param) {
      let formData = new FormData()
      formData.append('file', param.file)
      this.startProgress()
      this.$http.post(`/api/excelUpload/salesman/inquiry?userId=${this.user.id}`, formData).then((res) => {
        if (res.data.success) {
          this.progressVal = 100;
          window.location.href = `/#/inquiryNew/create/excel/${res.data.data}`
        } else {
          this.endProgress()
          this.$message.warning(res.data.message)
        }
      })
    },
    addVal() {
      if (this.progressVal <= 95) {
        this.progressVal++;
      }
    },
    startProgress() {
      this.progressDisplay = true;
      this.timer = setInterval(this.addVal, 500);
    },
    handleRemove(file, fileList) {
    },
    handlePreview(file) {
    },
    handleExceed(files, fileList) {
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    async delInfo(item) {
        var _this = this
        this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var params = {
            userId: this.user.id,
            companyId:this.user.customerId,
            pid:item.pid,
          }
          this.$http.post('/api/ucenter/pur/purOrder/delItem',params).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: 'success'
              });
              this.goodsInfo.forEach(function(row,index){
                  if(row.pid == item.pid){
                    _this.goodsInfo.splice(index,1)
                  }
              })
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
  
      },
    async del(id) {
      this.$confirm('此操作将永久删除该商品, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var params = {
          userId: this.user.id,
          companyId:this.user.customerId,
          pid:id,
        }
        this.$http.post('/api/ucenter/pur/purOrder/del',params).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "删除成功",
              type: 'success'
            });
            this.index(this.page)
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    updatePrice(id, price) {
      this.$http.get('/api/ucenter/updatePrice', { params: { id, price } }).then((res) => {
        if (res.data.success) {
          this.$message({
            message: "操作成功",
            type: 'success'
          });
        }
      });
    },
    index(page) {
      this.page = page
      var params = {
        userId: this.user.id,
        page: page,
        companyId:this.user.customerId,
        pageSize: 10
      }
      if(this.search.title!=""){
        params.search = this.search
      }
      this.$http.get('/api/ucenter/pur/purOrder/list', {
        params: params
      }).then((res) => {
        res.data.data = res.data.data ? res.data.data : []
        this.goods = res.data.data
        this.total = res.data.total
      })
    },
    cateIndex() {
      this.$http.get('/api/category').then((res) => {
        this.cates = res.data.data
      })
    },
    brandIndex() {
      this.$http.get('/api/brand').then((res) => {
        this.brands = res.data.data
      })
    },
    presclassIndex() {
      this.$http.get('/api/chuffl').then((res) => {
        this.presclass = res.data.data
      })
    },
    resetForm(form) {
      this.search.title = ""
      this.index(1)
    },
    handleSelectionChange(val) {
      this.selectedGoods = val
    },
    uploadImage(param) {
      let formData = new FormData()
      formData.append('file', param.file)
      this.$http.post('/api/fileUpload', formData).then((res) => {
        if (res.data.success) {
          this.form.image.push(res.data.message)
        } else {
          this.$message.warning(res.data.message)
        }
      })
    },

 
  }
}



// WEBPACK FOOTER //
// ./src/views/user/purchaserManagement/purchaserManagement.js